import gql from 'graphql-tag';

export const GET_DISCOVERED_VENUE_SEARCH_RESULTS = gql`
  query getVenueDiscoveryDiscoveredVenues($params: VenueDiscoveryInput!) {
    searchDiscoveredVenues(params: $params) {
      name
      transactions
      cnvsCnvenueUuid
      address {
        address1
        city
        state
        postal
        country
      }
      cardNetworkId {
        cardNetwork
        cardNetworkExternalId
        cardNetworkExternalIdType
      }
    }
  }
`;

export default GET_DISCOVERED_VENUE_SEARCH_RESULTS;
